/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DispatchStatusType {
    UnPlanned = 100,
    PlannedOnHold = 102,
    PlannedReady = 103,
    Offered = 104,
    OfferedRefused = 106,
    OfferedTimedOut = 108,
    Started = 110,
    Completed = 120,
    CrossDockOrder = 210,
    Unknown = 0,
}
